module.exports = __webpack_public_path__ + "img/9788925516981.e18382f1.jpg";